// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__3N2TP","selected":"Checkbox_selected__2uQ5F"};